// ISO27001Certification.jsx
import React from "react";

export default function ISO27001Certification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISO 27001 Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISO 27001 Information Security Certification Support
          </h1>
          <div className="w-20 h-1 bg-indigo-600 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists organizations with ISO 27001
            Certification for information security management, helping design
            and implement an ISMS aligned with ISO/IEC 27001:2022
            requirements.[web:379][web:377]
          </p>
          <p className="text-gray-700">
            The service focuses on building a risk‑based information security
            framework that protects critical assets, supports customer trust,
            and meets audit expectations in a practical way.[web:377][web:381]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-indigo-500 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5380655/pexels-photo-5380655.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Cybersecurity dashboard representing information security management"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISO 27001 Certification
            </h2>
            <p className="text-gray-700 mb-4">
              ISO 27001 requires defined ISMS documentation, risk management
              evidence, and organisational information, with specific mandatory
              documents and records.[web:373][web:380]
            </p>
            <div className="bg-gray-50 border border-indigo-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  ISMS documentation such as scope, information security policy,
                  Statement of Applicability, risk treatment plan, and core
                  procedures for key security and operational controls.[web:373][web:375][web:380]
                </li>
                <li>
                  Risk assessment records, including methodology, risk
                  assessment and treatment reports, asset inventory, identified
                  risks, selected controls, and residual risk decisions.[web:373][web:375]
                </li>
                <li>
                  Company details and context information, such as
                  organisational structure, legal identity, relevant statutory
                  and contractual requirements, and defined roles and
                  responsibilities.[web:375][web:381]
                </li>
                <li>
                  Required records like training and competence records,
                  monitoring and measurement results, internal audit and
                  management review outputs, and corrective action
                  evidence.[web:373][web:374]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The service is designed to turn ISO 27001 into a practical ISMS
              that strengthens real security posture while meeting certification
              requirements.[web:377][web:381]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-indigo-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Information Security Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on interpreting ISO 27001 clauses and Annex A
                  controls, mapping them to your technology, processes, and
                  regulatory environment.[web:377][web:380]
                </p>
              </div>

              <div className="border-l-4 border-indigo-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Compliance Approach
                </h3>
                <p className="text-gray-700 text-sm">
                  Stepwise support from scoping and risk assessment through
                  documentation, implementation, internal audits, and
                  certification audit readiness.[web:377][web:381]
                </p>
              </div>

              <div className="border-l-4 border-indigo-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing advisory for maintaining the ISMS, closing audit
                  findings, and preparing for surveillance and recertification
                  cycles.[web:381][web:382]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-indigo-600 text-indigo-700 font-medium hover:bg-indigo-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
